<div class="ui-breadcrumb">
  <ul class="breadcrumb-list-block">
    <li v-for="item in datas"><a class="text-block" href="javascript:;" @click="onClick(item.link)">{{item.text}}</a>
    </li>
  </ul>
</div>